import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import type { Role } from '../types/api';

/**
 * Gates a route on authentication. Redirects to /login while preserving
 * the attempted location in router state so we can bounce back after login.
 */
export function ProtectedRoute({ requireRole }: { requireRole?: Role }) {
  const { user, status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    // Splash placeholder. Could swap to a thin top loading bar in Phase 5+.
    return null;
  }
  if (status === 'unauthenticated' || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (requireRole && user.role !== requireRole) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
